import { render, staticRenderFns } from "./PriceBlock.vue?vue&type=template&id=1a0d241d&scoped=true&"
import script from "./PriceBlock.vue?vue&type=script&lang=ts&"
export * from "./PriceBlock.vue?vue&type=script&lang=ts&"
import style0 from "./PriceBlock.vue?vue&type=style&index=0&id=1a0d241d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0d241d",
  null
  
)

component.options.__file = "PriceBlock.vue"
export default component.exports